import React from "react";
import { Icon } from "@fluentui/react/lib/Icon";
import styled from "styled-components/macro";

export default function OfficeeEngineeringBanner({ slug }: { slug: string }): JSX.Element {
    if (slug !== "office") {
        return null;
    }
    return (<Wrapper aria-label="Office Engineering Information">
        <p> Coming soon! We will be moving Office Engineering System Support to a Teams Channel, date TBD. Please check <a href="https://aka.ms/OMREngHelp" target="_blank" rel="noreferrer">OMREngHelp</a> for the most recent announcements. </p>

    </Wrapper>);
}

const Wrapper = styled.div`
    padding: 2rem;
    margin: 2rem 0;
    border: 0.1rem solid var(--color-info);
    border-top: 0.4rem solid var(--color-info);
    border-radius: 0.2rem;
    box-shadow: 0px 0.3px 0.9px rgb(0 0 0 / 11%),0px 1.6px 3.6px rgb(0 0 0 / 13%);
    background-color: var(--color-surface);

`;